/* global google */

import React from 'react';
import {
  GoogleMap, useJsApiLoader,
} from '@react-google-maps/api';
import Geocode from 'react-geocode';
import { GMAPS_API_KEY } from '../../../config/envConf';

Geocode.setApiKey(GMAPS_API_KEY!);
Geocode.setLanguage('en');
Geocode.setRegion('us');

const libraries : ['places'] = ['places'];

interface Props {
  position: google.maps.LatLng | google.maps.LatLngLiteral;
  options?: google.maps.MapOptions | undefined;
  children?: React.ReactElement | React.ReactElement[];
}

const Gmaps = (props: Props) => {
  const {
    options, children,
    position = { lat: 33.87887555901595, lng: -117.58957369840054 },
  } = props;
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GMAPS_API_KEY!,
    libraries,
  });

  if (!isLoaded) {
    return (
      <div className="border border-1 w-100 h-100 flexible-center">
        Loading...
      </div>
    );
  }

  return (
    <GoogleMap
      center={position}
      zoom={15}
      mapContainerClassName="w-100 h-100"
      options={options}
    >
      {children}
    </GoogleMap>
  );
};

export default Gmaps;
